import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const FinancialAndSale = ({
  onChange,
  disabled,
  error,
  financial_title,
  sales_title,
  financial_sales,
  buyer_contacts,
  onContactsSearch,
  ...props
}) => {
  var data = {};

  const handleChange = event => {
    onChange(event, "financial_sales");
  };

  const handleContactsAsyncChange = (event, values) => {
    if (!values) {
      values = { id: "" };
    }
    event.target.value = values.id;
    event.target.name = event.target.id;
    onChange(event, "financial_sales");
  };

  const handleContactsAsyncSearch = (event, values) => {
    onContactsSearch(values);
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {financial_title}
      </Typography>

      <TextField
        id="pledgde_number"
        name="pledgde_number"
        label="Prenda Nro"
        disabled={disabled}
        type="text"
        placeholder="Ingrese el nro de prenda"
        onChange={handleChange}
        value={financial_sales.pledgde_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="pledgde_duedate"
        name="pledgde_duedate"
        label="Prenda Vto."
        disabled={disabled}
        type="date"
        placeholder="Ingrese la fecha de vto de prenda"
        onChange={handleChange}
        value={financial_sales.pledgde_duedate}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="pledgde_closure_date"
        name="pledgde_closure_date"
        label="Prenda Cierre"
        disabled={disabled}
        type="date"
        placeholder="Ingrese la fecha de cierre de prenda"
        onChange={handleChange}
        value={financial_sales.pledgde_closure_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      {/*<Typography variant="h6" className="mt-2">
            {sales_title}
        </Typography>

        <Autocomplete
            id={"buyer_contact_id"}
            style={{ width: 200 }}
            getOptionLabel={(option) => option.hansa_name}
            getOptionSelected={(option, value) => option.hansa_name === value}           
            options={buyer_contacts.options}
            loading={buyer_contacts.loading}
            value={buyer_contacts.options.find(v => v.id === financial_sales.buyer_contact_id) || {}}
            onInputChange={handleContactsAsyncSearch}
            onChange={handleContactsAsyncChange.bind(this)}
            autoComplete
            noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
            name={"buyer_contact_id"}
            includeInputInList
            className="mt-3 mr-2"
            classes={{
                option: classes.option,
            }}
            renderInput={(params) => (
            <TextField
                {...params}
                placeholder="Ingrese un contacto"
                name={"buyer_contact_id"}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                        {buyer_contacts.loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                    }}
                    InputLabelProps={{ ...params.InputLabelProps,
                            shrink: true
                            }}
                    inputProps={{
                                ...params.inputProps,
                                style:{fontSize: '0.75rem', width: 70}
                            }}

            />
            )}
        />
        <TextField
            id="buyer_purchase_date"
            name="buyer_purchase_date"
            label="Fecha venta"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de venta"
            onChange={handleChange}
            value={financial_sales.buyer_purchase_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
            shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
        />

        <TextField
            id="buyer_transfer_date"
            name="buyer_transfer_date"
            label="Fecha tranferencia"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de tranferencia"
            onChange={handleChange}
            value={financial_sales.buyer_transfer_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
            shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
        />*/}
    </React.Fragment>
  );
};

export default FinancialAndSale;
